module.exports = __webpack_public_path__ + "static/img/14.9d34ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/14.png
// module id = 4LTc
// module chunks = 0